
import { defineComponent, ref, onMounted, computed } from 'vue';
import X from '@/components/web3/x.vue';
import useTokens from '../../composables/PolarisFinance/useTokens';
import { useRoute } from 'vue-router';
import useWeb3 from '@/services/web3/useWeb3';
import useSunrise from '../../composables/PolarisFinance/useSunrise';
import { parseFixed } from '@ethersproject/bignumber';

import useTransactions from '@/composables/useTransactions';
import { TransactionResponse } from '@ethersproject/providers';
import useEthers from '../../composables/useEthers';

/**
 * STATE
 */
const textInput = ref<HTMLInputElement>();
/**
 * LIFECYCLE
 */
onMounted(() => {
  textInput.value?.focus();
});
export default defineComponent({
  components: {
    X,
  },
  props: {
    isVisible: Boolean,
    depositBol: Boolean,
    balance: { type: String, default: '0' },
  },
  setup(props, { emit }) {
    const { getProvider } = useWeb3();

    const route = useRoute();
    const { addTransaction } = useTransactions();
    const { txListener } = useEthers();

    const txHandler = (tx: TransactionResponse): void => {
      addTransaction({
        id: tx.hash,
        type: 'tx',
        action: 'stake',
        summary: 'deposit for sunrise',
      });
    };

    async function deposit(amount: string) {
      const formatedAmount = parseFixed(amount, 18);
      const tokenName = route.params.id.toString();
      const { deposit } = useSunrise(tokenName);
      const tx = await deposit(formatedAmount, getProvider());
      txHandler(tx);
      txListener(tx, {
        onTxConfirmed: () => {
          emit('close');
          emit('update');
        },
        onTxFailed: () => {},
      });
    }

    async function withdraw(amount: string) {
      const formatedAmount = parseFixed(amount, 18);
      const tokenName = route.params.id.toString();
      const { withdraw } = useSunrise(tokenName);
      const tx = await withdraw(formatedAmount, getProvider());
      txHandler(tx);
      txListener(tx, {
        onTxConfirmed: () => {
          emit('close');
          emit('update');
        },
        onTxFailed: () => {},
      });
    }

    return {
      deposit,
      withdraw,
    };
  },

  data() {
    return {
      inputValue: '0',
    };
  },
  methods: {
    maxBalance() {
      this.inputValue = this.balance;
    },
  },

  emits: ['close', 'update'],
});
